import { useEffect, useRef } from 'preact/hooks';
import { forwardRef } from 'preact/compat';
import { tryFocus } from '@/utils';

export default function Group({
	children,
	focusInvalid,
	index,
	show,
	block = {},
	typeCount = 1,
	_id
}) {
	const groupRef = useRef(null);

	const className = `control-group question ${
		block.typeName !== 'rating' ? block.typeName : ''
	}-group ${block.typeName}-group-${typeCount} ${block.tooltip ? 'has-tooltip' : ''} ${
		block.typeName === 'screenshot' && block.properties?.bottomScreen
			? 'section absolute'
			: ''
	}`;

	const id = `${block.typeName}-${block.id}${
		block.typeName === 'special_input' ? `-${_id}` : ''
	}`;

	const WrappingComponent =
		['select', 'textarea', 'input', 'special_input', 'contact', 'section_break'].indexOf(
			block.typeName
		) > -1
			? 'div'
			: 'fieldset';

	useEffect(() => {
		if (focusInvalid) {
			try {
				groupRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
			} catch (e) {}
			tryFocus(
				groupRef.current.querySelector('input, textarea, .ui-stars-star, .nice-select')
			);
		}
	}, [focusInvalid, groupRef]);

	return (
		<section
			className={className}
			style={{ display: show ? 'block' : 'none' }}
			data-index={index}
			key={id}
			id={id}
			ref={groupRef}
			data-testid={`${block.typeName}-group`}
			tabIndex="-1" //needed to keep tab focus order intact after reading (onclick) this element with a screenreader.
		>
			<WrappingComponent>{children}</WrappingComponent>
		</section>
	);
}
